import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/button/featured-job-favorite-button.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobAccessTracker"] */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/job-access-tracker.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/jobs/client-action-buttons.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/jobs/client-job-details-floating-buttons.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/jobs/client-usage-flow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/jobs/job-image-slide.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/jobs/job-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/jobs/job-same-company.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4234673916/src/kenshoku-bank/nextjs/src/components/shared/horizontal-slide-form.tsx");
